import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Plus, UsersRound } from "lucide-react";

import RoleItem from "./RoleItem";
import { UIEmptyState } from "../../../ui";
import messages from "../../../../assets/locale/messages";

import "../Zones/EmptyZonesState.scss";

const EventRoles = ({ event, portalVariant, onAddRole }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events.viewEvents;

  const roles =
    event?.event_roles ??
    event?.event_roles_attributes ??
    [];

  if (!roles.length) {
    // Same empty state as the Zones tab.
    return (
      <UIEmptyState
        title={t.emptyRolesTitle}
        description={t.emptyRolesDescription}
        icon={<UsersRound size={40} strokeWidth={1.5} />}
        actionLabel={t.addNewRole}
        actionIcon={<Plus size={18} />}
        onAction={onAddRole}
        classNames={{
          description: "empty-zones-state__description",
          iconCircle: "empty-zones-state__icon-circle",
        }}
      />
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {roles.map((role, idx) => (
        <RoleItem
          key={role?.id ?? role?.role_id ?? idx}
          role={role}
          defaultExpanded={idx === 0}
          portalVariant={portalVariant}
        />
      ))}
    </Box>
  );
};

EventRoles.propTypes = {
  event: PropTypes.object,
  portalVariant: PropTypes.oneOf(["company-portal", "client-portal"]),
  onAddRole: PropTypes.func,
};

EventRoles.defaultProps = {
  event: null,
  portalVariant: "company-portal",
  onAddRole: undefined,
};

export default EventRoles;
